import {useTranslation} from '@/translations/i18n'
import {AlertCircleIcon} from '@/components/ui/icon/Icon'
import {useOutletContext} from 'react-router-dom'
import {ProjectExtended} from '@/features/projects/types'
import {ErrorBox} from '@/components/commons/error-box/ErrorBox'
import {AccessesCard} from '../accesses-card/AccessesCard'
import {AccessesEmptyCard} from '../accesses-empty-card/AccessesEmptyCard'
import {useGetAccessesDetail} from '@/features/accesses/queries/useGetAccessesDetail'
import {ResponseType} from '@/types'
import {useMemo} from 'react'
import {useGetPlannedAccessesDetails} from '@/features/planned-accesses/queries/useGetPlannedAccessesDetails'
import {StyledAccessesSection} from './style'

export const AccessesSection = () => {
    const {project} = useOutletContext<{project: ProjectExtended}>()
    const {t} = useTranslation()
    const {
        data: accesses,
        isLoading: isLoadingAccesses,
        isError: isErrorAccesses,
        error: errorAccesses
    } = useGetAccessesDetail({
        params: {
            projectId: project.id,
            responseType: ResponseType.enum.extended
        }
    })
    const {data: plannedAccesses, isLoading: isLoadingPlannedAccesses} = useGetPlannedAccessesDetails({
        urlParams: {
            projectId: project.id
        }
    })

    const isEmpty = useMemo(() => {
        return (
            accesses?.in_person_accesses.length === 0 &&
            accesses?.non_in_person_accesses.length === 0 &&
            accesses?.treatments.length === 0
        )
    }, [accesses])

    return (
        <StyledAccessesSection>
            {isErrorAccesses && errorAccesses?.response?.data.code !== 'project-access-not-found' ? (
                <ErrorBox icon={<AlertCircleIcon />} title={t('errors:default')} />
            ) : isEmpty || isLoadingAccesses || isLoadingPlannedAccesses ? (
                <AccessesEmptyCard isLoading={isLoadingAccesses || isLoadingPlannedAccesses} />
            ) : (
                accesses && <AccessesCard accesses={accesses} plannedAccesses={plannedAccesses} />
            )}
        </StyledAccessesSection>
    )
}
